import React, {memo, ReactNode, useCallback} from 'react';
import {CONTROL_TYPE_ID_MKK, ControlModel, ControlTypeModel, ThreePhaseSet} from '../../types/control';
import {useRPC} from '../../hooks/rpc';
import {ThreePhaseControlComponent} from './component';
import {useDispatch} from 'react-redux';
import {useDebounce} from '../../hooks/debounce';
import {entityUpdatedAction} from '../../store/control/actions';
import {useQuestion} from "../../hooks/question";
import {useLocalization} from "../../hooks/localization";

export enum PhaseStatus {
    Stop,
    Up,
    Down
}

type Props = {
    control: ControlModel;
    controlType: ControlTypeModel<ThreePhaseSet>;
    children?: ReactNode;
};

export const ThreePhaseControl = memo(function CurtainControl(props: Props) {
    const {control, children, ...restProps} = props;
    const question = useQuestion();
    const {t} = useLocalization();

    const [rpc] = useRPC();
    const updateControl = useDebounce(rpc.updateControlValue, 200);

    const dispatch = useDispatch();

    const openAreYouSure = useCallback(status => {
        question(t('ARE_YOU_SURE'), () => {
            dispatch(entityUpdatedAction({...control, isUpdating: true}, 'control'));
            updateControl(control.id, status);
        });
    }, [control, question, t, dispatch, updateControl]);

    const click = useCallback((status: PhaseStatus) => {
        if (control.type_id === CONTROL_TYPE_ID_MKK) {
            openAreYouSure(status);
        } else {
            dispatch(entityUpdatedAction({...control, isUpdating: true}, 'control'));
            updateControl(control.id, status);
        }
    }, [control, openAreYouSure, updateControl, dispatch]);

    return (
        <ThreePhaseControlComponent control={control} click={click} {...restProps}>
            {children}
        </ThreePhaseControlComponent>
    );
});
